define [], () ->
  helper =  (str, maxlen) ->
    if str.length > maxlen?
      str.substr(0, maxlen - 3) + "..."
    else
      str

  helper



// WEBPACK FOOTER //
// ./app/scripts/Hasadna/oBudget/Misc/handlebarsHelpers/strOverflow.coffee